var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.667,
    viewBox: "0 0 16 15.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Heading",
    d: "M-1062.473-400.333a.526.526,0,0,1-.526-.526.526.526,0,0,1,.526-.526h10.737a.525.525,0,0,1,.526.526.525.525,0,0,1-.526.526Zm0-3.036a.526.526,0,0,1-.526-.526.526.526,0,0,1,.526-.526h13.894a.525.525,0,0,1,.526.526.525.525,0,0,1-.526.526Zm0-3.158a.526.526,0,0,1-.526-.526.526.526,0,0,1,.526-.527h13.894a.525.525,0,0,1,.526.527.525.525,0,0,1-.526.526Zm0-3.158a.526.526,0,0,1-.526-.526v-5.263a.527.527,0,0,1,.526-.527h14.947a.527.527,0,0,1,.526.527v5.263a.526.526,0,0,1-.526.526Zm.868-1.245h13.276v-3.756H-1061.6Z",
    transform: "translate(1063 416)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeading);
export default __webpack_public_path__ + "static/media/Icon_Heading.495b5492.svg";
export { ForwardRef as ReactComponent };